import './Footer.css';
import { DOMAINS, getCurrentEnvironment } from '../../utils/constants';

// Shared footer HTML – same as static website (footerTemplate.js)
import footerTemplate from './footerTemplate.js';

const getFooterHtml = footerTemplate.getFooterHtml;

export interface FooterProps {
  className?: string;
  /** Lucid: single bar, copyright left / links right */
  variant?: 'default' | 'lucid' | 'full';
}

const Footer = ({ className = '', variant = 'default' }: FooterProps) => {
  const env = getCurrentEnvironment();
  const websiteBase = env === 'local' ? DOMAINS.LOCAL.WEBSITE : DOMAINS.PRODUCTION.WEBSITE;
  const portalLogin = env === 'local' ? `${DOMAINS.LOCAL.PORTAL}/login` : `${DOMAINS.PRODUCTION.PORTAL}/login`;
  const links = (
    <>
      <li><a href="https://www.zivohealth.ai/privacy-policy.html">Privacy Policy</a></li>
      <li><a href="https://www.zivohealth.ai/terms-and-conditions.html">Terms and Conditions</a></li>
      <li><a href={`${websiteBase}/delete-account.html`}>Delete Account</a></li>
    </>
  );

  if (variant === 'full') {
    const footerInnerHtml = getFooterHtml({
      websiteBase,
      portalLoginUrl: portalLogin,
      logoSrc: '/images/zivo_logo.png',
      deleteAccountHref: `${websiteBase}/delete-account.html`,
    });
    return (
      <footer
        className={`footer-design ${className}`.trim()}
        dangerouslySetInnerHTML={{ __html: footerInnerHtml }}
      />
    );
  }

  if (variant === 'lucid') {
    return (
      <footer className={`footer-lucid ${className}`.trim()}>
        <div className="footer-bottom">
          <p>&copy; 2026 ZivoHealth. All rights reserved.</p>
          <ul>{links}</ul>
        </div>
      </footer>
    );
  }

  return (
    <footer className={className || ''}>
      <div className="footer-content">
        <div className="footer-section">
          <ul>{links}</ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 ZivoHealth. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
